<template>

    <ui-icon v-bind:style="{fontSize:'1.5em'}" v-on:click.native.stop.prevent="goHome()" class="icon" backgroundColor="#DDDDDD" color="#666666" icon="home"></ui-icon>

</template>

<script>

import UiIcon from '../UiIcon.vue'
import { mapState } from 'vuex';
import { modalService } from '../../services/ModalService.js'

export default {
  name: 'icon-button-home',
  props:{
    overrideClick:{default:false},
  },
  computed:{
    ...mapState(['user_schools'])
  },
  data:function(){
    return {
      
    }
  },
  methods:{
    goHome(){
      var school = this.user_schools.find(school => school.active === 1);
      if (school){
        // an active school is found: we are logged in
        
        // pass on click to do alternative stuff on the outside of component
        this.$emit('click');
        
        if(!this.overrideClick){
          // if no override then go home normally
          this.$router.push({ path: '/' }) // goin to home
        }
        

      }else{
        modalService.createAlert(this.$t("language.not_loggedin_on_school")).then(
          () => { /* ok */ }
        )
      }
      
    }
  },
  components:{
    UiIcon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
  cursor:pointer
}
</style>
